import script from "./NewSolutionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewSolutionModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewSolutionModal.vue?vue&type=style&index=0&id=5a098d8a&scoped=true&lang=css"
import "./NewSolutionModal.vue?vue&type=style&index=1&id=5a098d8a&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a098d8a"]])

export default __exports__